/**
 * Client-side impersonation state. An admin can choose to act as another member;
 * the selected member id is persisted in localStorage and attached to every API
 * request via the impersonation header. The backend only honours it for admins.
 */

const STORAGE_KEY = 'catalyst-psa.impersonate-member-id';

/** Returns the member id currently being impersonated, or null. */
export function getImpersonatedMemberId(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

/** Persists the impersonated member id (or clears it when null). */
export function setImpersonatedMemberId(memberId: string | null): void {
  try {
    if (memberId) {
      window.localStorage.setItem(STORAGE_KEY, memberId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage unavailable (private mode, etc.) — impersonation simply won't persist.
  }
}
